<template>
  <div class="mobile-container">
    <page-header>{{'大会日程' | dealLanguage('Conference Agenda')}}</page-header>
    <div class="main-content">
      <div class="first-froum" @click="handleClick(froum_list[0]['activityId'])">
        <div class="froum-title">
          <span>{{froum_list[0]['activityName'] | dealLanguage(froum_list[0]['enActivityName'])}}</span>
        </div>
      </div>
      <div class="froum-list">
        <div class="froum-li" v-for="(item, index) in froum_list.slice(1)" :key="index" @click="handleClick(item.activityId)">
          <div class="froum-title">{{ item.activityName | dealLanguage(item.enActivityName)}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import { getAgendaList } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: filter.dealLanguage('大会日程', 'Conference Agenda'),
    }
  },
  inject: ['globalInsertRecords', 'wxShare'],
  data () {
    return {
      froum_list: [],
    }
  },

  components: {
    PageHeader
  },

  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
      vbef_path: (state) => state.vbef_path,
    })
  },

  created() {
    this.getAgendaList()
  },

  mounted() {
    this.wxShare({
      title: filter.dealLanguage('大会日程-CSGCT', 'Conference Agenda-CSGCT'),
      linkurl: this.vbef_path + '/theme',
    })
  },

  methods: {
    async getAgendaList() {
      this.loading = true
      let res = await getAgendaList({
        actId: this.activityId,
        assortName: '',
        dateName: '',
      })
      this.loading = false
      if (res.code == 0) {
        this.$set(this.$data, 'froum_list', res.data.activities)
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleClick(activityId) {
      this.$router.push({
        path: '/agenda',
        query: {
          id: activityId,
        },
      })
    },
  },
}
</script>
<style lang='stylus' scoped>
.mobile-container
  .main-content
    padding .4rem
    .first-froum
      background-image url('~pic/theme-bg.png')
      background-repeat no-repeat
      background-size 100% 100%
      height 1.8rem
      display flex
      align-items center
      cursor pointer
      .froum-title
        width 100%
        height .8rem
        background linear-gradient(90deg, rgba(255, 167, 98, 0.6) 0%, #FF7000 53%, rgba(255, 167, 98, 0.6) 100%)
        padding 0 .4rem
        font-weight 400
        font-size .24rem
        color #FFFFFF
        line-height 1.5
        display flex
        align-items center
        justify-content center
  .froum-list
    display grid
    grid-template-columns repeat(2, 1fr)
    grid-auto-rows 1.8rem
    .froum-li
      background-image url('~pic/theme-icon.png')
      background-repeat no-repeat
      background-size .89rem .86rem
      background-position right bottom
      border 1px solid #ED6D01
      padding .2rem
      display flex
      align-items center
      cursor pointer
      transition: all .3s ease-in-out
      &:hover
        background-color: #FFE8D9
      &:nth-child(n+3)
        border-top 0
      &:not(:nth-child(2n+1))
        border-left 0
      .froum-title
        width 100%
        font-weight 400
        font-size .24rem
        color #C7000C
        line-height .36rem
</style>